import {Loader} from '@googlemaps/js-api-loader';

export function addressAutocomplete() {
    let wonderContestForm = document.querySelector('.wondercontest-form');
    if (!wonderContestForm) return;

    const loader = new Loader({
        apiKey: menaObject.mapKey,
        libraries: ['places'],
    });

    let $ = jQuery;

    loader.load().then(() => {
        initAutocomplete();

        $(document).on('gform_page_loaded', function (event, form_id, current_page) {
            initAutocomplete();
        });
    });

    function initAutocomplete() {
        const inputAddress = document.querySelector('.js-wondercontest-address input');
        const inputStreetNumber = document.querySelector('.js-wondercontest-street-number input');
        const inputCity = document.querySelector('.js-wondercontest-city input');
        const inputPostalCode = document.querySelector('.js-wondercontest-postal-code input');

        if (!inputAddress) return;

        const options = {
            componentRestrictions: {country: 'be'},
            fields: ['address_components', 'geometry'],
        };
        const autocomplete = new google.maps.places.Autocomplete(inputAddress, options);

        autocomplete.addListener('place_changed', () => {
            // Get the place details from the autocomplete object.
            const place = autocomplete.getPlace();
            const streetNumber = place.address_components.find((component) => component.types.includes('street_number'));
            const city = place.address_components.find((component) => component.types.includes('locality'));
            const postalCode = place.address_components.find((component) => component.types.includes('postal_code'));

            // Only return street address
            const address = place.address_components.find((component) => component.types.includes('route'));

            //Set address.long_name to inputAddress
            if (address) {
                inputAddress.value = address.long_name;
            }

            // Set street number
            if (streetNumber) {
                inputStreetNumber.value = streetNumber.long_name;
            }

            // Set city
            if (city) {
                inputCity.value = city.long_name;
            }

            // Set postal code
            if (postalCode) {
                inputPostalCode.value = postalCode.long_name;
            } else {
                inputPostalCode.classList.add('active');
            }

            if (!address) {
                inputAddress.value = '';
                return;
            }


        });
    }
}

export function handleFormStatus() {
    let $ = jQuery;

    // Assistance contest only. The sponsorship contest is rendered by the same
    // template without the page-level modifier, so everything below is a no-op
    // there and its markup keeps the classes it has today.
    const contestPage = document.querySelector('.wonder-contest--assistance');

    // The <form> carries .ws-contest-assistance; on the confirmation Gravity
    // Forms replaces it, so the page modifier is the durable half of the gate.
    function assistanceForm() {
        if (!contestPage) return null;

        const wrapper = contestPage.querySelector('.wondercontest-form');

        return wrapper && wrapper.querySelector('.ws-contest-assistance') ? wrapper : null;
    }

    // Gravity Forms renders every page of the form and hides all but the
    // current one. Reading that back beats the event's own current_page
    // argument, which is the page that was *submitted*: after a validation
    // error page 2 is re-rendered but announced as the source page, and a cold
    // load never fires the event at all.
    function currentPage(wrapper) {
        const pages = wrapper.querySelectorAll('.gform_page');

        if (!pages.length) return 1;

        let page = 0;

        pages.forEach((node) => {
            if (page || window.getComputedStyle(node).display === 'none') return;

            const match = node.id.match(/_(\d+)$/);

            page = match ? Number(match[1]) : 0;
        });

        return page || 1;
    }

    // Idempotent on purpose: it runs on every render, so going back to page 1
    // and a re-render after a validation error both land on the right state.
    function syncStep() {
        const wrapper = assistanceForm();

        if (!wrapper) return;

        const onStep2 = currentPage(wrapper) === 2;
        wrapper.classList.toggle('wondercontest-form--step-2', onStep2);
        // Page-level twin of the form modifier: the hero is a sibling of the
        // form, so hiding it on step 2 (operator, 2026-09-18) needs a marker
        // on the element that contains both.
        contestPage.classList.toggle('wonder-contest--step-2', onStep2);
    }

    syncStep();

    $(document).on('gform_page_loaded', function (event, form_id, current_page) {
        if (current_page == 2) {
            let formStep2 = document.querySelector('.wondercontest-form__step--2');
            if (formStep2) {
                formStep2.classList.add('active');
            }
        }

        syncStep();
    });

    // gform_post_render also covers the re-render after a validation error,
    // which does not change page and so never fires gform_page_loaded.
    $(document).on('gform_post_render', syncStep);

    $(document).on('gform_confirmation_loaded', function (event, form_id) {
        let formStep3 = document.querySelector('.wondercontest-form__step--3');
        if (formStep3) {
            formStep3.classList.add('active');
        }

        // Assistance contest only: the heading above the form belongs to the
        // form steps, not to the confirmation. The sponsorship contest has no
        // .ws-contest-assistance wrapper, so it never gets the modifier.
        const wonderForm = document.querySelector('.wondercontest-form');
        if (wonderForm && wonderForm.querySelector('.ws-contest-assistance')) {
            wonderForm.classList.add('wondercontest-form--confirmed');
            // The step modifier describes the form's pages; they are gone now.
            wonderForm.classList.remove('wondercontest-form--step-2');
        }

        // The hero lives outside .wondercontest-form, so the class that hides
        // it has to sit on the nearest element that contains both — which is
        // the same element every assistance-only rule is already scoped to.
        if (contestPage) {
            contestPage.classList.add('wonder-contest--confirmed');
            contestPage.classList.remove('wonder-contest--step-2');
        }
    });
}

export function FormModals() {
    const modalConsentTriggers = document.querySelectorAll('.js-consent .gfield_description span');
    const modalConsentCloseTriggers = document.querySelectorAll('.wondercontest-dialog--consent .wondercontest-dialog__close');
    const modalConsent = document.querySelector('.wondercontest-dialog--consent');

    if (modalConsent && modalConsentTriggers) {
        modalConsentTriggers.forEach((trigger) => {
            trigger.addEventListener('click', () => {
                // Make sure modal is scrolled to the top
                modalConsent.scrollTop = 0;
                modalConsent.showModal();
            });
        });
        modalConsentCloseTriggers.forEach((trigger) => {
            trigger.addEventListener('click', () => {
                modalConsent.close();
            });
        });
    }

    const modalRulesTriggers = document.querySelectorAll('.js-rules');
    const modalRulesCloseTriggers = document.querySelectorAll('.wondercontest-dialog--rules .wondercontest-dialog__close');

    if (modalRulesTriggers) {
        const modalRules = document.querySelector('.wondercontest-dialog--rules');

        modalRulesTriggers.forEach((trigger) => {
            trigger.addEventListener('click', (ev) => {
                ev.preventDefault();
                // Make sure modal is scrolled to the top
                modalRules.scrollTop = 0;
                modalRules.showModal();
            });
        });
        modalRulesCloseTriggers.forEach((trigger) => {
            trigger.addEventListener('click', () => {
                modalRules.close();
            });
        });
    }

    const modalRulesPrivacyTriggers = document.querySelectorAll('.js-privacy');
    const modalRulesClosePrivacy = document.querySelectorAll('.wondercontest-dialog--privacy .wondercontest-dialog__close');

    if (modalRulesPrivacyTriggers) {
        const modalPrivacy = document.querySelector('.wondercontest-dialog--privacy');

        modalRulesPrivacyTriggers.forEach((trigger) => {
            trigger.addEventListener('click', (ev) => {
                ev.preventDefault();
                modalPrivacy.showModal();
                // Make sure modal is scrolled to the top
                modalPrivacy.scrollTop = 0;

            });
        });
        modalRulesClosePrivacy.forEach((trigger) => {
            trigger.addEventListener('click', () => {
                modalPrivacy.close();
            });
        });
    }
}

export function rulesDeepLink() {
    const modalRules = document.querySelector('.wondercontest-dialog--rules');

    if (!modalRules) return;

    const HASH = '#reglement';

    const writeHash = (hash) => {
        const url = window.location.pathname + window.location.search + hash;
        window.history.replaceState(null, '', url);
    };

    // FormModals() already opens the dialog on .js-rules — only add the URL.
    document.querySelectorAll('.js-rules').forEach((trigger) => {
        trigger.addEventListener('click', () => writeHash(HASH));
    });

    modalRules.addEventListener('close', () => {
        if (window.location.hash === HASH) {
            writeHash('');
        }
    });

    if (window.location.hash === HASH) {
        modalRules.scrollTop = 0;
        if (!modalRules.open) {
            modalRules.showModal();
        }
    }
}

export function garagePreselect() {
    const wonderContestForm = document.querySelector('.wondercontest-form');

    if (!wonderContestForm) return;

    const $ = jQuery;
    const garages = (typeof menaObject !== 'undefined'
        && menaObject.wsContest
        && menaObject.wsContest.garages) || {};

    const slugify = (value) => String(value)
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');

    // A native event reaches both addEventListener and jQuery handlers;
    // chosen:updated is jQuery-only and refreshes the enhanced select.
    const fireChange = (el) => {
        el.dispatchEvent(new Event('change', {bubbles: true}));
        $(el).trigger('chosen:updated');
    };

    // Measured on ws2: when the enhanced UI is on, Chosen announces a pick
    // with jQuery's synthetic `change` only — a native addEventListener
    // handler never sees it. Everything below therefore listens through
    // jQuery, which catches the synthetic event AND a native dispatch.
    const onChange = (el, handler) => $(el).on('change', handler);

    // The garage only ever supplies a *default* language — once the visitor
    // picks one themselves we never overwrite it again.
    let languageTouched = false;
    let applyingLanguage = false;
    let presetApplied = false;

    // ?g= may carry the garages CPT slug (what the QR sheets are generated
    // from), the slugified title, or either of those without the shared
    // "wonderservice-" prefix. Tried in that order; first hit wins.
    function findGarageOption(select, wanted) {
        const target = slugify(wanted);

        if (!target) return null;

        const options = Array.from(select.options)
            .filter((o) => o.value && o.value !== 'empty');

        const strip = (value) => value.replace(/^wonderservice-/, '');
        const cptSlug = (o) => {
            const garage = garages[o.value];
            return garage && garage.slug ? slugify(garage.slug) : '';
        };

        return options.find((o) => cptSlug(o) === target)
            || options.find((o) => slugify(o.value) === target)
            || options.find((o) => strip(slugify(o.value)) === target)
            || options.find((o) => cptSlug(o) && strip(cptSlug(o)) === target)
            || null;
    }

    function applyLanguageDefault(garageSelect) {
        const langSelect = document.querySelector('.ws-contest-lang select');

        if (!langSelect || languageTouched) return;

        const garage = garages[garageSelect.value];

        if (!garage || !garage.lang) return;

        const option = Array.from(langSelect.options)
            .find((o) => o.value.toLowerCase() === garage.lang);

        if (!option || langSelect.value === option.value) return;

        applyingLanguage = true;
        langSelect.value = option.value;
        fireChange(langSelect);
        applyingLanguage = false;
    }

    function init() {
        const garageSelect = document.querySelector('.ws-contest-garage select');

        if (!garageSelect || garageSelect.dataset.wsGarageBound === '1') return;

        garageSelect.dataset.wsGarageBound = '1';

        const langSelect = document.querySelector('.ws-contest-lang select');

        if (langSelect && langSelect.dataset.wsLangBound !== '1') {
            langSelect.dataset.wsLangBound = '1';
            onChange(langSelect, () => {
                if (!applyingLanguage) {
                    languageTouched = true;
                }
            });
        }

        onChange(garageSelect, () => applyLanguageDefault(garageSelect));

        const wanted = new URLSearchParams(window.location.search).get('g');

        // Applied once per page load: Gravity Forms re-renders the form after
        // a validation error and on the way back from page 2, and re-applying
        // ?g= there would overwrite a garage the visitor picked themselves.
        if (!wanted || presetApplied) return;

        const option = findGarageOption(garageSelect, wanted);

        if (!option) return;

        presetApplied = true;
        garageSelect.value = option.value;
        fireChange(garageSelect);
    }

    init();

    // gform_post_render fires on every render (incl. validation errors);
    // gform_page_loaded only on a page change. Both are re-entrant-safe.
    $(document).on('gform_post_render gform_page_loaded', function () {
        init();
    });
}

/**
 * Gravity Forms' "enhanced user interface" replaces the two campaign selects
 * with the Chosen widget it ships. Chosen only marks a control as showing its
 * placeholder when the selected option's value is the empty string — the
 * garage placeholder carries the value "empty" — so the class that paints the
 * placeholder in the placeholder grey has to be maintained from here.
 *
 * No-op when the enhanced UI is off: without a .chosen-container there is
 * nothing to paint.
 */
export function enhancedSelects() {
    const form = document.querySelector('.wonder-contest--assistance .wondercontest-form');

    if (!form) return;

    const $ = jQuery;
    // Every select of the campaign form (garage, language, the page-2
    // question) — Gravity Forms wraps each in .gfield--type-select.
    const SELECTS = '.gfield--type-select select';
    const PLACEHOLDER_VALUES = ['', 'empty'];

    function paint(select) {
        const field = select.closest('.gfield');
        const container = field ? field.querySelector('.chosen-container') : null;

        if (!container) return;

        container.classList.toggle(
            'ws-chosen-placeholder',
            PLACEHOLDER_VALUES.indexOf(select.value) !== -1,
        );
    }

    function init() {
        form.querySelectorAll(SELECTS).forEach((node) => {
            const select = node;

            paint(select);

            if (select.dataset.wsChosenBound === '1') return;

            select.dataset.wsChosenBound = '1';
            $(select).on('change', () => paint(select));
        });
    }

    // GF registers its own Chosen init on gform_post_render too, and handler
    // order between the two bundles is not guaranteed — the extra frame runs
    // after every synchronous handler of the same event, so the widget always
    // exists by then.
    function initNowAndAfterChosen() {
        init();
        window.requestAnimationFrame(init);
    }

    initNowAndAfterChosen();

    $(document).on('gform_post_render gform_page_loaded', initNowAndAfterChosen);
}

export function handleSponsors() {

    function handleSponsorsSelect() {
        let selectWonderservice = document.querySelector('.js-sponsor-select .gfield-choice-input[value="wonderservice"]');
        let selectWondercar = document.querySelector('.js-sponsor-select .gfield-choice-input[value="wondercar"]');
        let successMessage = document.querySelector('.js-wondercontest-response--correct');
        let wrongMessage = document.querySelector('.js-wondercontest-response--wrong');
        let responseTextCorrect = document.querySelector('.js-response-message-text.correct');
        let responseTextIncorrect = document.querySelector('.js-response-message-text.incorrect');

        if (!selectWonderservice || !selectWondercar) return;

        selectWonderservice.addEventListener('change', () => {
            if (selectWonderservice.checked) {
                successMessage.classList.add('active');
                wrongMessage.classList.remove('active');
            }

            responseTextCorrect.classList.add('active');

            if (responseTextIncorrect.classList.contains('active')) {
                responseTextIncorrect.classList.remove('active');
            }
        });

        selectWondercar.addEventListener('change', () => {
            if (selectWondercar.checked) {
                wrongMessage.classList.add('active');
                successMessage.classList.remove('active');
            }
            responseTextIncorrect.classList.add('active');

            if (responseTextCorrect.classList.contains('active')) {
                responseTextCorrect.classList.remove('active');
            }
        });
    }

    handleSponsorsSelect();

    $(document).on('gform_page_loaded', function (event, form_id, current_page) {
        handleSponsorsSelect();
    });
}

export function heroName() {
    // Get url parameter called name
    const urlParams = new URLSearchParams(window.location.search);
    let fullName = urlParams.get('firstName');
    const lastName = urlParams.get('lastName');

    if (lastName) {
        fullName = `${fullName} ${lastName}`;
    }

    const wondercontestHero = document.querySelector('.wondercontest-hero .js-p-name');

    if (!fullName || !wondercontestHero) return;

    wondercontestHero.textContent = fullName;
}

export function copyLink() {

    function initCopyLink() {
        const copyLinkItem = document.querySelector('.js-copy-share-link');

        if (!copyLinkItem) return;

        // Copy href from element to clipboard and add class active the element and remove it after 3s
        copyLinkItem.addEventListener('click', (ev) => {
            console.log('clicked');
            ev.preventDefault();
            const link = copyLinkItem.getAttribute('href');
            navigator.clipboard.writeText(link).then(() => {
                copyLinkItem.classList.add('active');
                setTimeout(() => {
                    copyLinkItem.classList.remove('active');
                }, 3000);
            });
        });
    }

    function resendEmail() {
        const resendEmailButton = document.querySelector('.js-resend-email');

        if (!resendEmailButton || resendEmailButton.dataset.wsResendBound === '1') return;

        resendEmailButton.dataset.wsResendBound = '1';

        const entry = resendEmailButton.dataset.entry;
        const token = resendEmailButton.dataset.token;

        // Sponsorship contest: no signed token, keep the original behaviour.
        if (!entry || !token) {
            resendEmailButton.addEventListener('click', (ev) => {
                ev.preventDefault();
                // Add loading class to button for 2s and then add active class
                resendEmailButton.classList.add('loading');
                setTimeout(() => {
                    resendEmailButton.classList.remove('loading');
                    resendEmailButton.classList.add('active');
                }, 1000);

            });
            return;
        }

        const strings = (typeof menaObject !== 'undefined' && menaObject.wsContest) || {};
        const errorField = document.querySelector('.wondercontest-confirmation__error');
        const label = resendEmailButton.querySelector('.wondercontest-confirmation__resend-label');
        const originalLabel = label ? label.textContent : '';
        // Operator, 2026-09-18: the button must not be a one-shot. After a
        // successful send it reads "Email envoyé" for as long as the server
        // cooldown lasts, then goes back to its label and accepts a new click.
        const RESEND_REENABLE_MS = 30000;

        // showError() paints a message, falling back to the generic one; it
        // must never be used to CLEAR the field — an empty argument falls
        // through to the generic error, which is exactly what visitors saw:
        // "L'envoi a échoué" painted on click, then never wiped after the
        // successful send turned the button into "Email envoyé ✓".
        const showError = (message) => {
            if (errorField) {
                errorField.textContent = message || strings.error || '';
            }
        };
        const clearError = () => {
            if (errorField) {
                errorField.textContent = '';
            }
        };

        resendEmailButton.addEventListener('click', (ev) => {
            ev.preventDefault();

            if (resendEmailButton.classList.contains('loading')
                || resendEmailButton.classList.contains('active')) return;

            clearError();
            resendEmailButton.classList.add('loading');

            jQuery.ajax({
                url: menaObject.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'ws_contest_resend',
                    entry: entry,
                    token: token,
                },
            }).done((response) => {
                resendEmailButton.classList.remove('loading');

                if (response && response.success) {
                    clearError();
                    if (label) {
                        label.textContent = (response.data && response.data.message) || strings.emailSent || label.textContent;
                    }
                    resendEmailButton.classList.add('active');
                    setTimeout(() => {
                        resendEmailButton.classList.remove('active');
                        // A cooldown message painted meanwhile is stale now.
                        clearError();
                        if (label) {
                            label.textContent = originalLabel;
                        }
                    }, RESEND_REENABLE_MS);
                    return;
                }

                showError(response && response.data && response.data.message);
            }).fail(() => {
                resendEmailButton.classList.remove('loading');
                showError('');
            });
        });
    }

    initCopyLink();
    resendEmail();

    $(document).on('gform_confirmation_loaded', function (event, form_id) {
        initCopyLink();
        resendEmail();
    });

}
